import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 no-underline">
              <span className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-book-open-line text-white text-lg"></i>
              </span>
              <span className="font-heading font-bold text-xl text-white">虫虫漫画</span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed">
              免费阅读的在线漫画平台，提供最新最全的漫画资源。热血、恋爱、玄幻、搞笑、悬疑等丰富品类，更新同步，是漫画爱好者的首选。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm">快速导航</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-foreground-300 hover:text-primary-400 text-sm transition-colors">
                  网站首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-foreground-300 hover:text-primary-400 text-sm transition-colors">
                  漫画分类
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-300 hover:text-primary-400 text-sm transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm">热门分类</h4>
            <ul className="space-y-2">
              {categories.slice(1, 7).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-300 hover:text-primary-400 text-sm transition-colors"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@chongchongmanga.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-line text-primary-400"></i>
                <span>在线客服：周一至周日 9:00-21:00</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>中国·杭州</span>
              </li>
            </ul>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-8 h-8 bg-foreground-800 rounded-lg flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 bg-foreground-800 rounded-lg flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 bg-foreground-800 rounded-lg flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="QQ" rel="nofollow">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 虫虫漫画 ChongChongManga.com 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <a href="#" className="hover:text-primary-400 transition-colors">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}